import api from '../api'

const state = {
  all: [],
  client: null
}

const actions = {
  getClients: ({ state, commit }) => {
    return api.getAllClients().then(clients => {
      return commit('setAllClients', clients)
    })
  },
  getClient: ({ state, commit }, id) => {
    return api.getSingleClient(id).then(client => {
      return commit('setSingleClient', client)
    })
  },
  getClientOverview: ({ state, commit }, id) => {
    var params = {params: {'include_invoices': 1}}
    return api.getSingleClient(id, params).then(client => {
      return commit('setSingleClient', client)
    })
  },
  updateClient: ({ state, commit }, data) => {
    return api.updateSingleClient(data).then(client => {
      return commit('setSingleClient', client)
    })
  },
  addClient: ({ state, commit }, data) => {
    return api.addSingleClient(data).then(client => {
      return commit('setSingleClient', client)
    })
  },
  deleteClient: ({ state, commit }, id) => {
    return api.deleteSingleClient(id).then(() => {
      return commit('setSingleClient', null)
    })
  },
  uploadImage: ({ state, commit }, data) => {
    return api.uploadSingleImage(data).then((user) => {
      return commit('setSingleClient', user)
    })
  },
  deleteImage: ({ state, commit }, id) => {
    return api.deleteSingleImage(id).then((user) => {
      return commit('setSingleClient', user)
    })
  }
}

const mutations = {
  setAllClients (state, clients) {
    state.all = clients
  },
  setSingleClient (state, client) {
    state.client = client
  },
  resetSingleClient (state) {
    state.client = null
  }
}

const getters = {
  all: state => {
    return state.all
  },
  client: state => {
    return state.client
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/clients.js